<div>
  <form *ngIf="form" [formGroup]="form">
    <app-vital-sign-input [definition]="this.def" [form]="form"></app-vital-sign-input>
  </form>
</div>
